import { render, staticRenderFns } from "./reportePtiInversionV2.vue?vue&type=template&id=21f8ff71&scoped=true"
import script from "./reportePtiInversionV2.vue?vue&type=script&lang=js"
export * from "./reportePtiInversionV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f8ff71",
  null
  
)

export default component.exports